// Single source of truth for broadcast enums (send-via / status). Every
// other module — server services, server route schemas, web queries, web
// components — imports from here. Const arrays drive both the TypeScript
// union types AND the Zod schemas, so a new enum member can be added in
// exactly one place.
//
// The legacy `audience` enum was dropped in the Phase 3 audience-spec
// migration (server migration 0070). Audience targeting is fully driven
// by the structured `AudienceSpec` shape — see
// `apps/server/src/groups/service/audience-spec.ts`.
//
// sendVia values:
//   - 'email' — SES only (no in-app notification fires, the email lands in
//     the recipient's inbox).
//   - 'email_in_app' — SES email + in-app notification feed entry
//     (group-leader broadcasts use this; the in-app row reads
//     "From {groupName}: {subject}").
//   - 'dm' — a one-way announcement direct message from the Lean In
//     official account. Platform admins only, platform-class audiences only;
//     no email is sent by the broadcast itself (the DM's own `message.new`
//     notification follows the member's direct-message preferences).
import { z } from 'zod';
export const BROADCAST_SEND_VIAS = [
    'email',
    'email_in_app',
    'dm',
];
export const BroadcastSendViaSchema = z.enum(BROADCAST_SEND_VIAS);
// The channels that deliver the broadcast as an email (subject, rich body,
// preheader, reply-to). Group-leader broadcasts may only use these.
export const BROADCAST_EMAIL_SEND_VIAS = ['email', 'email_in_app'];
export const BroadcastEmailSendViaSchema = z.enum(BROADCAST_EMAIL_SEND_VIAS);
export const BROADCAST_STATUSES = ['draft', 'scheduled', 'sent'];
export const BroadcastStatusSchema = z.enum(BROADCAST_STATUSES);
//# sourceMappingURL=broadcast-enums.js.map